import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectAllowEdit = () => createSelector(substate, (contextState) => contextState.allowEdit);
